import React from 'react';
import _ from 'lodash';

import {
  Divider,
  List,
  Typography
} from '@mui/material';

import { DateTime } from 'luxon';
import * as ChatMessageListItem from './ChatMessageListItem';



export interface IMessage {
  id: string;
  senderUserName: string;
  content: string;
  metaCreated: DateTime;
}

export interface IProps {
  messages: IMessage[];
}

export const FC: React.FC<IProps> = props => {
  return !_.isEmpty(props.messages) ? (
    <List>
      {_.map(props.messages, (message, index) => (
        <React.Fragment key={message.id}>
          <ChatMessageListItem.FC
            key={message.id}
            messageId={message.id}
            content={message.content}
            metaCreated={message.metaCreated}
            triggeringUserName={message.senderUserName} />

          {(index < props.messages.length - 1) && (
            <Divider variant="inset" />
          )}
        </React.Fragment>
      ))}
    </List>

  ) : (
    <Typography>
      No messages
    </Typography>
  );
};
